import lodash from "lodash";
import React, { useContext } from "react";
import { RicosContext } from "./../../ricos-context/index.js";
import generalStyles from "../../editor-common/statics/styles/general-scss.js";
import generalRTLIgnoredStyles from "../../wix-rich-content-common/statics/styles/general.rtlignore-scss.js";
const stylesWithRTL = { ...generalStyles, ...generalRTLIgnoredStyles };
import classNames from "classnames";
import classes from "./figure-scss.js";
const Figure = ({ NodeViewContent, ...props }) => {
  const { isMobile } = useContext(RicosContext);
  const pmNode = props.node.toJSON();
  const mainChild = pmNode.content[0];
  if (!mainChild) {
    return null;
  }
  const width = getContainerWidth(mainChild.attrs, isMobile);
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      style: { width: width ? `min(100%, ${width}px)` : void 0 },
      "data-hook": `figure-${mainChild.type}`,
      className: getContainerClasses(mainChild.attrs.containerData)
    },
    /* @__PURE__ */ React.createElement(NodeViewContent, { as: "figure", className: classes.figure })
  );
};
const getContainerWidth = (nodeData, isMobile) => {
  const disableCustomWidthMapper = nodeData?.image?.width && isMobile && (Number(nodeData?.containerData?.width?.custom) || 0) > 150;
  const disableCustomWidth = disableCustomWidthMapper ?? false;
  const customWidth = !disableCustomWidth ? nodeData?.containerData?.width?.custom : void 0;
  const originalWidth = nodeData?.containerData?.width?.size === "ORIGINAL" || disableCustomWidth ? nodeData?.image?.width : void 0;
  const width = customWidth || originalWidth;
  return width;
};
const getContainerClasses = (containerData) => {
  const alignment = containerData?.alignment;
  const alignmentClassName = alignment ? stylesWithRTL[`align${lodash.upperFirst(alignment.toLowerCase())}`] : void 0;
  const size = containerData?.width?.size;
  const sizeClassName = size && size !== "FULL_WIDTH" ? stylesWithRTL[`size${lodash.upperFirst(size.toLowerCase())}`] : void 0;
  const textWrap = containerData?.textWrap;
  const textWrapClassName = textWrap ? void 0 : stylesWithRTL.textWrapNowrap;
  return classNames(alignmentClassName, sizeClassName, textWrapClassName);
};
export {
  Figure
};
//# sourceMappingURL=figure.js.map
